import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from './FormatUtils';

const AmountInput = ({ value, onChange, placeholder, className = "input input-bordered w-full", required = false, ...props }) => {
    const { t } = useTranslation();
    const resolvedPlaceholder = placeholder ?? t('amountInput.placeholder');
    const [isEditing, setIsEditing] = useState(false);
    const [displayValue, setDisplayValue] = useState('');

    useEffect(() => {
        if (!isEditing) {
            const hasValue = value !== '' && value !== null && value !== undefined;
            setDisplayValue(hasValue ? formatMoney(value) : '');
        }
    }, [value, isEditing]);

    const handleFocus = () => {
        setIsEditing(true);
        const hasValue = value !== '' && value !== null && value !== undefined;
        setDisplayValue(hasValue ? value.toString() : '');
    };

    const handleBlur = () => {
        setIsEditing(false);
    };

    const handleChange = (e) => {
        const inputValue = e.target.value;
        setDisplayValue(inputValue);

        // Permettre la saisie de nombres avec virgule ou point
        const raw = inputValue.replace(/\s/g, '').replace(',', '.');
        const num = parseFloat(raw);

        onChange(isNaN(num) ? '' : num);
    };

    return (
        <input
            type="text"
            className={className}
            placeholder={resolvedPlaceholder}
            value={isEditing ? displayValue : formatMoney(value, { currency: false })}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            inputMode="decimal"
            required={required}
            {...props}
        />
    );
};

export default AmountInput;